import { useState } from "react";

// Shared by Milestones/Recurring/Resources (BillableItemsResultsPage): each
// table's column-sort state and toggle logic are wired up identically.
export const useTableSort = (
  initialOrderBy: string,
  initialDataType: "string" | "date" | "number" = "string"
) => {
  const [sort, setSort] = useState<any>({
    orderBy: initialOrderBy,
    criteria: "asc",
    dataType: initialDataType,
  });

  const sortBy = (orderBy: any, dataType: "string" | "date" | "number") => {
    let criteria: "asc" | "desc" = "asc";
    if (sort.orderBy === orderBy) {
      criteria = sort.criteria === "asc" ? "desc" : "asc";
    }
    setSort({
      orderBy,
      criteria,
      dataType,
    });
  };

  return { sort, sortBy };
};
